export const ADD_BRDC = 'ADD_BRDC'
export const NEW_BRDC = 'NEW_BRDC'
export const DEL_BRDC = 'DEL_BRDC'